import React from 'react';
import SubBanner from '../components/SubBanner';
import ContactInfo from '../components/ContactInfo';
import ContactForm from '../components/ContactForm';

const ContactPage = () => {
    // The Google Map can be added here if needed, or within its own component
    const mapIframe = `
        <div class="float-left w-100 contact-map-con position-relative padding-top padding-bottom">
            <div class="container p-0 wow animate__animated animate__fadeInDown">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.367176743588!2d144.95736461590413!3d-37.81813957974638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65cbce858f6d7%3A0x9cc486b305ba3fb1!2s21%20King%20St%2C%20Melbourne%20VIC%203000%2C%20Australia!5e0!3m2!1sen!2s!4v1669200882885!5m2!1sen!2s"
                    allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </div>
        </div>
    `;

    return (
        <>
            <SubBanner title="Contact Us" breadcrumb="Contact" />
            <ContactInfo />
            <ContactForm />
            <div dangerouslySetInnerHTML={{ __html: mapIframe }} />
        </>
    );
};

export default ContactPage;